module.exports = __webpack_public_path__ + "img/banner-1.8d27cbe8.png";